// components/ActionButtons/ActionButtons.jsx
import React from 'react';
import { Button, Row, Col, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import NumberFormat from 'react-number-format';

const ActionButtons = ({ onContinueClick = () => {}, disabled = false, preOrder = null }) => {
  const translate = useSelector((state) => getTranslate(state.localize));
  const user = useSelector((state) => state.user);
  const cartReport = useSelector((state) => state.cart.cart_report);
  console.log({ cartReport });
  return (
    <>
      {/* Desktop Button */}
      <div className='d-flex justify-content-end' style={{ marginInline: '20px' }}>
        <Button onClick={onContinueClick} disabled={disabled} className='btn mt-3 btn-primary d-none d-sm-block ' style={{ color: 'white' }}>
          {translate('last_confirm')}
        </Button>
      </div>

      {/* Mobile Button Row */}
      <Row className='continue-ordering-row d-sm-none' style={{ paddingBottom: '30px' }}>
        <Col xs={12}>
          <div className='d-flex justify-content-between align-top'>
            <Button onClick={onContinueClick} disabled={disabled} className=' c-font-xs my-1 continue-ordering-button custom-continue-ordering-button' style={{ color: 'white' }}>
              {translate('last_confirm')}
            </Button>

            {!preOrder && (
              <div className='continue-ordering-price'>
                <span className='c-font-xs'>{user['is_teammate'] !== 1 ? translate('total_price') : translate('total_weight')}:</span>
                <br />
                {cartReport.total_price !== 0 ? (
                  <span className='c-font-sm bold' style={{ color: '#000' }}>
                    {user['is_teammate'] !== 1 ? (
                      <NumberFormat value={cartReport.total_price} displayType={'text'} suffix=' تومان ' thousandSeparator={true} />
                    ) : (
                      <NumberFormat value={cartReport.total_weight} suffix={` ${translate('weight-unit')} `} displayType={'text'} thousandSeparator={true} />
                    )}
                  </span>
                ) : (
                  <Spinner animation='border' className='mx-2 continue-ordering-price c-font-xs' style={{ width: '1rem', height: '1rem' }} />
                )}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ActionButtons;
